import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import { Button } from '@blueprintjs/core'
import {useStores, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './ErrorOnFlexLayoutLoadContainer.css'

/// region Components

interface MyProps {
  className?: string
}

export const ErrorOnFlexLayoutLoadContainer = observer<MyProps>(function ErrorOnFlexLayoutLoadContainer({className, ...props}) {
  const {reports: {createReport}} = useStores()

  return (
      <div className={classNames(css.root, className)}>
        <div className={css.grid}>
        <span className={css.text}>An error occurred while loading the report.</span>
        <div className={css.actions}>
          <Button icon='new-object' text='Open New Report' onClick={() => createReport(true)} />
        </div>
        </div>
      </div>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/ErrorOnFlexLayoutLoadContainer.tsx